import { Button } from "@repo/ui";
import { Github, Linkedin, Menu } from "lucide-react";
import { useState } from "react";
import { Link, NavLink } from "react-router-dom";

export function Nav() {
  const [open, setOpen] = useState(false);
  const linkBase =
    "px-3 py-2 text-sm md:text-base font-medium text-foreground/80 hover:text-foreground transition-colors";
  const active = "text-foreground";
  return (
    <header className="sticky top-0 z-40 backdrop-blur supports-[backdrop-filter]:bg-black/30 bg-black/30 border-b border-border">
      <div className="mx-auto max-w-6xl px-4 md:px-6 h-16 flex items-center justify-between">
        <Link to="/" className="flex items-center gap-2">
          <div className="size-8 rounded-md bg-gradient-to-br from-purple-400 to-purple-700 flex items-center justify-center text-black font-bold">
            JM
          </div>
          <span className="sr-only">Home</span>
        </Link>
        <nav className="hidden md:flex items-center gap-2">
          <NavLink to="/" end className={({ isActive }) => `${linkBase} ${isActive ? active : ""}`}>
            Home
          </NavLink>
          <NavLink
            to="/projects"
            className={({ isActive }) => `${linkBase} ${isActive ? active : ""}`}
          >
            Projects
          </NavLink>
          <NavLink
            to="/resume"
            className={({ isActive }) => `${linkBase} ${isActive ? active : ""}`}
          >
            Resume
          </NavLink>
          <NavLink
            to="/contact"
            className={({ isActive }) => `${linkBase} ${isActive ? active : ""}`}
          >
            <Button className="h-9 px-4">Hire me</Button>
          </NavLink>
        </nav>
        <div className="hidden md:flex items-center gap-3">
          <a href="#" aria-label="LinkedIn" className="text-foreground/70 hover:text-foreground">
            <Linkedin className="size-5" />
          </a>
          <a href="#" aria-label="GitHub" className="text-foreground/70 hover:text-foreground">
            <Github className="size-5" />
          </a>
        </div>
        <button
          className="md:hidden p-2 text-foreground/80"
          onClick={() => setOpen(!open)}
          aria-label="Menu"
        >
          <Menu />
        </button>
      </div>
      {open && (
        <div className="md:hidden border-t border-border bg-background/90">
          <div className="px-4 py-3 flex flex-col">
            <NavLink
              to="/"
              onClick={() => setOpen(false)}
              className={({ isActive }) => `${linkBase} ${isActive ? active : ""}`}
            >
              Home
            </NavLink>
            <NavLink
              to="/projects"
              onClick={() => setOpen(false)}
              className={({ isActive }) => `${linkBase} ${isActive ? active : ""}`}
            >
              Projects
            </NavLink>
            <NavLink
              to="/resume"
              onClick={() => setOpen(false)}
              className={({ isActive }) => `${linkBase} ${isActive ? active : ""}`}
            >
              Resume
            </NavLink>
            <NavLink
              to="/contact"
              onClick={() => setOpen(false)}
              className={({ isActive }) => `${linkBase} ${isActive ? active : ""}`}
            >
              Hire me
            </NavLink>
          </div>
        </div>
      )}
    </header>
  );
}
